<template>
	<div>
		<div class="title">
			<div class="header">
				<div class="header_title-container title">
					<h1>{{ $t("mailtest") }}</h1>
				</div>
			</div>
		</div>
		<div style="width: 100%" :style="{ height: height + 'px' }">
			<div style="width: 55%; margin-left: auto; margin-right: auto; overflow-y: auto; padding: 15px">
				<el-form class="demo-ruleForm">
					<el-form-item style="height: 60px">
						<strong slot="label">{{ $t("mailtest-dest") }}</strong>
						<el-input v-model="dest" />
					</el-form-item>
					<el-form-item style="height: 60px">
						<strong slot="label">{{ $t("mailtest-mitt") }}</strong>
						<el-input disabled v-model="mitt" />
					</el-form-item>
					<el-form-item style="height: 60px">
						<strong slot="label">{{ $t("mailtest-pecmitt") }}</strong>
						<el-input disabled v-model="pecmitt" />
					</el-form-item>
				</el-form>
				<div style="padding-top: 20px">
					<el-button type="primary" @click="sendTestMail('register-email')">{{
						$t("test-register-email")
					}}</el-button>
					<el-button type="primary" @click="sendTestMail('register-pec')">{{
						$t("test-register-pec")
					}}</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios"

export default {
	name: "MailTest",
	data() {
		return {
			dest: undefined,
			mitt: undefined,
			pecmitt: undefined,
			heightscreen: window.innerHeight - 120,
			height: window.innerHeight - 260
		}
	},
	created() {
		axios
			.get(process.env.VUE_APP_API_URL + "/api/email/getSender", {
				headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
			})
			.then(res => {
				this.mitt = res.data.mitt
				this.pecmitt = res.data.pecmitt
			})
			.catch(err => {
				this.$notification("error", this.$t("error"), err)
				console.error(err)
			})
	},
	methods: {
		sendTestMail(param) {
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/email/sendTest",
					{ dest: this.dest, param: param },
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					this.$notification("success", this.$t("email-success"), "")
				})
				.catch(err => {
					this.$notification("error", this.$t("email-error"), err)
					console.error(err)
				})
		}
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/my-form";

h3 {
	font-family: "Montserrat", sans-serif;
}
</style>
